import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["collapsedSummary", "expandedSummary"]

  connect() {
    this.toggleSummary(this.hasOpenCollapse())
  }

  expand() {
    this.toggleSummary(true)
  }

  collapse() {
    this.toggleSummary(false)
  }

  toggleSummary(isExpanded) {
    if (!this.hasCollapsedSummaryTarget && !this.hasExpandedSummaryTarget) return

    this.collapsedSummaryTargets.forEach((element) => {
      element.classList.toggle("d-none", isExpanded)
    })

    this.expandedSummaryTargets.forEach((element) => {
      element.classList.toggle("d-none", !isExpanded)
    })
  }

  hasOpenCollapse() {
    return this.element.querySelector(".collapse.show") !== null
  }
}
